import { Helmet } from 'react-helmet'
import 'swiper/css/bundle'

import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { DataProvider } from 'context/data-context'

const PageTitle = () => {
  return (
    <Helmet>
      <title>Главные фигуры: кто есть кто в Кремлевской партии</title>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  )
}

function App() {
  return (
    <DataProvider>
      <PageTitle />
      <GlobalStyle />
      <Home />
    </DataProvider>
  )
}

export default App
